import { DatePicker } from "@zendeskgarden/react-datepickers";
import { Field, Input } from "@zendeskgarden/react-forms";
import type { InputDateProps } from "./inputDateType";
import { useInputDate } from "./useInputDate";

export default function InputDateDefault({
  label,
  value,
  onChange,
  placeholder,
  locale = "pt-BR",
}: InputDateProps) {
  const {
    internalValue,
    handleChange,
    dateFormatter,
    handleManualInput,
    rawValue,
  } = useInputDate({ value, onChange, locale });

  return (
    <Field>
      {label && <Field.Label>{label}</Field.Label>}

      <DatePicker
        locale="pt-BR"
        value={internalValue}
        onChange={handleChange}
        formatDate={(date: Date) => dateFormatter.format(date)}
      >
        <Input
          placeholder={placeholder}
          value={
            rawValue ||
            (internalValue ? dateFormatter.format(internalValue) : "")
          }
          onChange={handleManualInput}
        />
      </DatePicker>
    </Field>
  );
}
